import script from "./TeacherHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./TeacherHeader.vue?vue&type=script&setup=true&lang=js"

import "./TeacherHeader.vue?vue&type=style&index=0&id=503df07c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-503df07c"]])

export default __exports__